<script setup lang="ts">
const layout = useLayout();
const root = useRoot();
</script>

<template>
  <footer class="relative mt-auto w-full bg-secondary">
    <div class="container py-12 lg:py-16">
      <div
        v-if="root.settings?.content?.footerLogo"
        class="mb-8 lg:mb-16"
      >
        <TheLogo
          v-if="root.settings?.content?.footerLogo"
          :logo="root.settings?.content?.footerLogo"
          loading="lazy"
          class="block w-fit"
        />
      </div>

      <div
        v-if="layout.isDesktop"
        class="grid gap-6 lg:grid-cols-12"
      >
        <div class="col-span-5">
          <AddressInformation
            v-for="(address, addressIndex) in root.settings?.content.address"
            :key="`address-${addressIndex}`"
            :address="address"
            class="mb-20"
          />
        </div>

        <div class="col-span-1 w-full text-white lg:col-span-7">
          <div
            v-if="root.settings?.content.quickLinks"
            class="gap-6 lg:flex lg:w-full lg:justify-end"
          >
            <div
              v-for="quickLinkColumn in root.settings?.content.quickLinks"
              :key="quickLinkColumn.content.headline"
              class="lg:w-1/3"
            >
              <p class="mb-2 font-bold">
                {{ quickLinkColumn.content.headline }}
              </p>
              <nav>
                <ul
                  :aria-label="$t('Aria.Global.Footer.QuickLinkList', { headline: quickLinkColumn.content.headline })"
                  class="grid gap-2"
                >
                  <li
                    v-for="quickLink in quickLinkColumn.content.links"
                    :key="quickLink.name"
                    class="hyphens-auto"
                  >
                    <UmbracoLink
                      :link="quickLink"
                      :has-underline="true"
                      class="text-base"
                    />
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <FooterMobileAccordion
          v-if="
            root.settings?.content.address
              || (Array.isArray(root.settings?.content.quickLinks) && root.settings?.content.quickLinks.length > 0)
          "
          :address-information="root.settings?.content.address"
          :quick-links="root.settings?.content.quickLinks ?? []"
        />
      </div>
    </div>

    <FooterBottomMenu />
  </footer>
</template>
